// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"x3-z"};